export default __webpack_public_path__ + "static/media/585_8.7c5b499e.jpg";